import Link from "next/link";
import Image from "next/image";
import type { BlogPostSummary } from "@/modules/blog/types";
import { mapNotionImageUrl } from "@/modules/blog/utils";

export default function BlogPostCard(props: Readonly<{ post: BlogPostSummary }>) {
  const p = props.post;
  const hero = p.heroImageUrl ? mapNotionImageUrl(p.heroImageUrl) : undefined;
  return (
    <article className="group relative overflow-hidden rounded-2xl border border-white/15 bg-white/10 backdrop-blur transition hover:bg-white/20 dark:border-white/10 dark:bg-white/5">
      {hero && (
        <Link href={`/blog/${p.slug}`} className="relative block" prefetch>
          <div className="relative aspect-[16/9] w-full overflow-hidden">
            <Image
              src={hero}
              alt={p.title}
              fill
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
              className="object-cover transition-transform duration-300 group-hover:scale-[1.02]"
            />
          </div>
        </Link>
      )}
      <div className="p-5">
        <div className="flex items-center justify-between gap-3 text-xs text-muted-foreground">
          <div className="inline-flex items-center gap-2">
            {p.publishedAt && (
              <time dateTime={p.publishedAt}>{new Date(p.publishedAt).toLocaleDateString()}</time>
            )}
          </div>
        </div>
        <h3 className="mt-2 text-lg font-semibold leading-snug text-foreground">
          <Link
            href={`/blog/${p.slug}`}
            className="hover:underline"
            data-cta="open-post-card"
            prefetch
          >
            {p.title}
          </Link>
        </h3>
        {p.excerpt && <p className="mt-1 line-clamp-3 text-sm text-foreground/80">{p.excerpt}</p>}
        {p.tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">
            {p.tags.map(function t(tg) {
              return (
                <span
                  key={tg}
                  className="rounded-md border border-white/15 px-2 py-0.5 text-xs text-foreground/80"
                >
                  {tg}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </article>
  );
}
